import { chooseObjectForReadonly } from "../utils/codeSplit";
import {
  chainedReducer as normalChainedReducer,
  timelineReducer as normalTimelineReducer
} from "./timelineReducer.normal";
import {
  chainedReducer as readonlyChainedReducer,
  timelineReducer as readonlyTimelineReducer
} from "./timelineReducer.readonly";

export const timelineReducer = chooseObjectForReadonly(readonlyTimelineReducer, normalTimelineReducer);
export const chainedReducer = chooseObjectForReadonly(readonlyChainedReducer, normalChainedReducer);
